var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.routeList
    ? _c(
        "div",
        { attrs: { id: "Allbtn" } },
        [
          _vm.showHelp
            ? _c(
                "div",
                { staticClass: "faceTipBox cursor" },
                [_c("faceTipBox1")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.showHelp
            ? _c(
                "div",
                {
                  staticClass: "kefuBox cursor",
                  on: { click: _vm.toggleServiceDialog }
                },
                [
                  _c("img", {
                    class:
                      _vm.$i18n.locale === "en" ? "kefuImgen" : "kefuImgcn",
                    attrs: {
                      src:
                        _vm.$i18n.locale === "en"
                          ? "https://img.webloom.cn/Img/KFen.png"
                          : "https://img.webloom.cn/Img/KFcn.png",
                      alt: ""
                    }
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$route.meta.Allbtn_info && !_vm.showHelp
            ? _c(
                "div",
                {
                  staticClass: "btnNew cursor",
                  on: {
                    mouseover: _vm.infoMouseover,
                    mouseout: _vm.infoMouseout
                  }
                },
                [
                  _c("img", {
                    staticClass: "btnIcon lingdangIcon",
                    attrs: {
                      src: "https://img.webloom.cn/Img/lingdang.png",
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _vm.$route.meta.Allbtn_info
                    ? _c(
                        "div",
                        { staticClass: "info" },
                        [
                          _c("transition", { attrs: { name: "fade" } }, [
                            _vm.infoDialog && _vm.noticeNo === 0
                              ? _c("div", { staticClass: "no_info" }, [
                                  _c("div", { staticClass: "no_info_title" }, [
                                    _vm._v(_vm._s(_vm.$t("flowFollowUs1")))
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "no_info_text" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "cursor",
                                        on: { click: _vm.toNotice }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("flowFollowUs2")))]
                                    )
                                  ])
                                ])
                              : _vm.infoDialog
                              ? _c(
                                  "div",
                                  { staticClass: "yes_info" },
                                  [
                                    _c("div", { staticClass: "yes_info_top" }, [
                                      _vm._v(_vm._s(_vm.$t("flowFollowUs3")))
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(_vm.noticeList, function(item) {
                                      return _c(
                                        "div",
                                        {
                                          key: item.noticeId,
                                          staticClass: "yes_info_li cursor",
                                          on: {
                                            click: function($event) {
                                              return _vm.toInfo(item)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "yes_info_li_title"
                                            },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(item.noticeTitle) +
                                                  "\n            "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "yes_info_li_time" },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(
                                                    item[
                                                      _vm.$t("flowMessage39")
                                                    ]
                                                      ? item[
                                                          _vm.$t(
                                                            "flowMessage39"
                                                          )
                                                        ]
                                                      : item.publishTimeStr
                                                  ) +
                                                  "\n            "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "yes_info_bottom" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "cursor",
                                            on: { click: _vm.toNotice }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("flowFollowUs4"))
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  2
                                )
                              : _vm._e()
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.showHelp
            ? _c(
                "div",
                { staticClass: "btnNew cursor", on: { click: _vm.advisoryFn } },
                [
                  _c("img", {
                    staticClass: "btnIcon lianxiIcon",
                    attrs: {
                      src: "https://img.webloom.cn/Img/concantus.png",
                      alt: ""
                    }
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.topBol
            ? _c(
                "div",
                {
                  staticClass: "btnNew cursor",
                  on: {
                    click: function($event) {
                      return _vm.$utils.backTop(1000)
                    }
                  }
                },
                [
                  _c("img", {
                    staticClass: "btnIcon topIcon",
                    attrs: {
                      src: "https://img.webloom.cn/Img/allbtnTop.png",
                      alt: ""
                    }
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.showHelp,
                  expression: "!showHelp"
                }
              ],
              staticClass: "smart-service"
            },
            [
              _c("transition", { attrs: { name: "service-fade" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.serviceDialogVisible,
                        expression: "serviceDialogVisible"
                      },
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.customerLoading,
                        expression: "customerLoading"
                      }
                    ],
                    staticClass: "service-dialog"
                  },
                  [
                    _c("div", { staticClass: "dialog-header" }, [
                      _c("div", { staticClass: "header-left" }, [
                        _c("div", { staticClass: "header-info" }, [
                          _c("div", { staticClass: "service-name" }, [
                            _vm._v(_vm._s(_vm.$t("customer10")))
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "header-right" }, [
                        _c("img", {
                          staticClass: "header-close",
                          attrs: {
                            src: "https://img.webloom.cn/img/activityClose.png",
                            alt: ""
                          },
                          on: { click: _vm.closeServiceDialog }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        ref: "dialogContent",
                        staticClass: "dialog-content",
                        on: { scroll: _vm.handleDialogScroll }
                      },
                      _vm._l(_vm.chatList, function(item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "message-list" },
                          [
                            item.operType >= 0 && item.operType <= 40
                              ? _c(
                                  "div",
                                  { staticClass: "message-item user-message" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "message-content" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "message-time" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$utils.timestampToStr(
                                                  item.questionSendTime,
                                                  "Y.M.D h:m:s"
                                                )
                                              ) + " "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#030A17"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("customer14"))
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "pre",
                                          {
                                            staticClass:
                                              "message-bubble user-bubble"
                                          },
                                          [_vm._v(_vm._s(item.question))]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "avatar" }, [
                                      _c("img", {
                                        staticClass: "avatar",
                                        attrs: {
                                          src: _vm.hearderImg,
                                          alt: "",
                                          onerror:
                                            "this.src='//img.webloom.cn/img/logo/default-user.png';this.onerror=null"
                                        }
                                      })
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "message-item service-message" },
                              [
                                _c("div", { staticClass: "avatar" }, [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        "https://img.webloom.cn/Img/customerImg1.png",
                                      alt: "客服头像"
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "message-content" }, [
                                  _c("div", { staticClass: "service-name" }, [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "#030A17" } },
                                      [_vm._v(_vm._s(_vm.$t("customer10")))]
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$utils.timestampToStr(
                                            item.answerSendTime,
                                            "Y.M.D h:m:s"
                                          )
                                        )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  item.operType > 10 &&
                                  item.operType < 20 &&
                                  !item.waitAnswer
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "message-bubble service-bubble"
                                        },
                                        [
                                          _c(
                                            "pre",
                                            {
                                              staticClass:
                                                "message-bubble-question"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(item.answer.question)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "pre",
                                            {
                                              staticClass:
                                                "message-bubble-answer messageTxt"
                                            },
                                            [_vm._v(_vm._s(item.answer.answer))]
                                          ),
                                          _vm._v(" "),
                                          item.operType === 12 &&
                                          item.answer &&
                                          item.answer.questionSimilarList &&
                                          item.answer.questionSimilarList
                                            .length > 0
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "related_issues"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "related_issues_title"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("customer16")
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    item.answer
                                                      .questionSimilarList,
                                                    function(q2, i) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: i,
                                                          staticClass:
                                                            "related_issues_item cursor",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.handleQuestionClick(
                                                                q2,
                                                                item.talkLogId
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "related_issues_item_txt ellipsis"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  q2.question
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("img", {
                                                            staticClass:
                                                              "right-img",
                                                            attrs: {
                                                              src:
                                                                "https://img.webloom.cn/Img/customerImg6.png",
                                                              alt: ""
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.operType == 12
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "None_above",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.solve(item, 70)
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("customer3"))
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.operType === 20 ||
                                  item.operType === 60 ||
                                  item.operType === 70
                                    ? _c(
                                        "div",
                                        { staticClass: "message-manual" },
                                        [
                                          _c(
                                            "pre",
                                            {
                                              staticClass: "message-manual-txt"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("customer4"))
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "message-manual-btn cursor",
                                              on: { click: _vm.makeComplaint }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("customer5"))
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.operType === 30
                                    ? _c(
                                        "div",
                                        { staticClass: "message-manual" },
                                        [
                                          _c(
                                            "pre",
                                            {
                                              staticClass: "message-manual-txt"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("customer2"))
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.operType === -2
                                    ? _c(
                                        "div",
                                        { staticClass: "message-manual" },
                                        [
                                          _c(
                                            "pre",
                                            {
                                              staticClass: "message-manual-txt"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("customer1"))
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.top5obj && item.operType == -1
                                    ? _c(
                                        "div",
                                        { staticClass: "message-top5" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "message-top5-title"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("customer9"))
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "message-top5-question-list"
                                            },
                                            _vm._l(
                                              _vm.top5obj &&
                                                _vm.top5obj.topFiveQuestion,
                                              function(q3, i) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: i,
                                                    staticClass:
                                                      "message-top5-question cursor",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.handleQuestionClick(
                                                          q3
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "pre",
                                                      {
                                                        staticClass:
                                                          "question ellipsis"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(q3.question)
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("img", {
                                                      staticClass: "right-img",
                                                      attrs: {
                                                        src:
                                                          "https://img.webloom.cn/Img/customerImg6.png",
                                                        alt: ""
                                                      }
                                                    })
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.waitAnswer
                                    ? _c(
                                        "div",
                                        { staticClass: "message-loadding" },
                                        [
                                          _c("img", {
                                            staticClass: "loading-icon1",
                                            attrs: {
                                              src:
                                                "https://img.webloom.cn/Img/chatLodding.gif",
                                              alt: "loading-icon1"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "loading-text" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("customer17"))
                                              ),
                                              _c("span", {
                                                staticClass: "loading-dots"
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            item.solveStatus == 10 ||
                            item.solveStatus == 20 ||
                            item.solveStatus == 30
                              ? _c("div", { staticClass: "resolved-status" }, [
                                  +item.solveStatus !== 20
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "yes",
                                          class:
                                            +item.solveStatus == 10
                                              ? "not"
                                              : "",
                                          on: {
                                            click: function($event) {
                                              return _vm.solve(item, 50)
                                            }
                                          }
                                        },
                                        [
                                          +item.solveStatus == 10
                                            ? _c("img", {
                                                staticClass: "status_img",
                                                attrs: {
                                                  src:
                                                    "https://img.webloom.cn/Img/yes1.png",
                                                  alt: ""
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          +item.solveStatus == 30
                                            ? _c("img", {
                                                staticClass: "status_img",
                                                attrs: {
                                                  src:
                                                    "https://img.webloom.cn/Img/yes2.png",
                                                  alt: ""
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "status_txt" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("customer7"))
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  +item.solveStatus !== 30
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "no",
                                          class:
                                            +item.solveStatus == 10
                                              ? "not"
                                              : "",
                                          on: {
                                            click: function($event) {
                                              return _vm.solve(item, 60)
                                            }
                                          }
                                        },
                                        [
                                          item.solveStatus == 10
                                            ? _c("img", {
                                                staticClass: "status_img",
                                                attrs: {
                                                  src:
                                                    "https://img.webloom.cn/Img/no1.png",
                                                  alt: ""
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.solveStatus == 20
                                            ? _c("img", {
                                                staticClass: "status_img",
                                                attrs: {
                                                  src:
                                                    "https://img.webloom.cn/Img/no2.png",
                                                  alt: ""
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "status_txt" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("customer8"))
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "dialog-input" }, [
                      _c("div", { staticClass: "dialog-btn" }, [
                        _c(
                          "div",
                          {
                            staticClass: "btn",
                            on: { click: _vm.contactHuman }
                          },
                          [
                            _c("img", {
                              staticClass: "weixin",
                              attrs: {
                                src:
                                  "https://img.webloom.cn/Img/customerImg3.png",
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "btn-txt" }, [
                              _vm._v(_vm._s(_vm.$t("customer11")))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "btn",
                            on: { click: _vm.makeComplaint }
                          },
                          [
                            _c("img", {
                              staticClass: "weixin",
                              attrs: {
                                src:
                                  "https://img.webloom.cn/Img/customerImg4.png",
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "btn-txt" }, [
                              _vm._v(_vm._s(_vm.$t("customer12")))
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-container" }, [
                        _c("img", {
                          staticClass: "send",
                          attrs: {
                            "data-v-1148cf8c": "",
                            src: "https://img.webloom.cn/Img/chatSend.png",
                            alt: ""
                          },
                          on: { click: _vm.sendMessage }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputMessage,
                              expression: "inputMessage"
                            }
                          ],
                          ref: "inputContainer",
                          staticClass: "message-input",
                          attrs: {
                            id: "inputContainer",
                            type: "text",
                            placeholder: _vm.lodding
                              ? _vm.$t("customer21")
                              : _vm.$t("customer13"),
                            maxlength: "500",
                            readonly: _vm.lodding
                          },
                          domProps: { value: _vm.inputMessage },
                          on: {
                            focus: _vm.messageFocus,
                            beforeinput: _vm.onBeforeInput,
                            keydown: _vm.sendMessage,
                            compositionstart: _vm.onCompositionStart,
                            compositionend: _vm.onCompositionEnd,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.inputMessage = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: false,
                  expression: "false"
                }
              ]
            },
            [_vm._v(_vm._s(_vm.language))]
          ),
          _vm._v(" "),
          _vm.showHelp
            ? _c("speakToStudent", { attrs: { showHelp: _vm.showHelp } })
            : _vm._e(),
          _vm._v(" "),
          _vm.dialogVisible
            ? _c(
                "el-dialog",
                {
                  attrs: {
                    "custom-class": "task_list_dialog_all",
                    modal: true,
                    "close-on-click-modal": false,
                    "close-on-press-escape": false,
                    visible: _vm.dialogVisible,
                    "lock-scroll": true,
                    width: "1000px"
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "dialog-title-all",
                      attrs: { slot: "title" },
                      slot: "title"
                    },
                    [
                      _c("div", { staticClass: "title-right" }, [
                        _c("img", {
                          staticClass: "iconImg",
                          attrs: {
                            src: "https://img.webloom.cn/img/gonggaoicontc.png",
                            alt: ""
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.dialogTitle.title))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "time" }, [
                        _vm._v(_vm._s(_vm.dialogTitle.time))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.dialogVisible
                    ? _c("noticeInfo", {
                        attrs: {
                          model: 2,
                          noticeId: _vm.userLatestNoticeInfo.noticeId || "",
                          topicId: _vm.$route.params.seasonId,
                          noticeNo: _vm.noticeNo
                        },
                        on: {
                          getdialogTitle: _vm.getdialogTitle,
                          close: _vm.toclose
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-868cb0cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-868cb0cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/public/all-btn.vue
// module id = null
// module chunks = 